import { authAPI, publicAuthAPI } from "./baseApi";

export interface IGetTokenDataRequest {
    emailOrUsername: string;
    password: string;
}

export interface IGetTokenResponse {
    accessToken: string;
    tokenType: string;
    refreshToken: string;
}

export interface IGetTokenWithGoogleTokenRequest {
    token: string;
}

export interface IRefreshTokenRequest {
    refreshToken: string;
}

export async function getToken(data: IGetTokenDataRequest) {
    return await publicAuthAPI.post<IGetTokenResponse>("/auth/login", data);
}

export async function getTokenWithGoogle(data: IGetTokenWithGoogleTokenRequest) {
    return await publicAuthAPI.post<IGetTokenResponse>("/auth/login/google", data);
}

export async function refreshToken(data: IRefreshTokenRequest) {
    return await publicAuthAPI.post<IGetTokenResponse>("/auth/refresh-token", data);
}

export async function logout() {
    return await authAPI.post<IGetTokenResponse>("/auth/logout");
}
